import React, { useEffect } from "react";
import { useLenis } from "../components/SmoothScroll";
import DoneIcon from "@mui/icons-material/Done";
import { Helmet } from "react-helmet-async";
const PrivacyPolicy = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, [lenisRef]);
  return (
    <>
    <Helmet>


   
      <title>Medical Privacy Policy | HIPAA Compalint |CDC

</title>
        <meta
          name="description"
          content="Understand how personal health information is collected, stored, and protected through HIPAA-compliant secure systems aligned with healthcare standards."
        />
        <meta
          name="keywords"
          content="medical privacy policy
healthcare privacy policy
healthcare data security
HIPAA Complaint


"
        />
 </Helmet>
      <div className="flex justify-center flex-col items-center  md:pt-20 pt-14 xl:pt-48 text-white">
        <div className="lg:w-[90%] w-[95%] mx-auto  flex flex-col items-center  pb-8 lg:pb-16">
          <h1 className="lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  px-4 mb-4 text-center capitalize w-full">
            {" "}
            Website Privacy Policy
          </h1>
          <div className="text-left mt-10">
            <h2 className="lg:text-[32px] lg:text-left text-center text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize">
              {" "}
              Citrus Diagnostic Center
            </h2>
            <p className="text-[#cccccc] mt-5 text-[17px] lg:text-left text-center leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-8 font-robout">
              Effective Date: January 1, 2026
            </p>

            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Scope of This Policy
            </h2>
            <p className=" text-[#cccccc] text-[17px] leading-[1.4em] font-normal  lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              This Website Privacy Policy applies only to information collected
              through the Citrus Diagnostic Center website. It does not apply to
              protected health information (PHI), which is governed by our
              <span className="font-extrabold">
                {" "}
                Notice of Privacy Practices
              </span>
            .
            </p>

            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Information We Collect
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              This website does not collect protected health information.
            </p>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              We may collect limited non-identifying information, such as:
            </p>
            <ul className="text-[#cccccc]  font-normal flex flex-col gap-3   pb-8  text-left font-robout">
              <li className="flex items-start gap-2"><DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">Browser type </span>{" "}
              </li>
              <li className="flex items-start gap-2"><DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">Device type </span>{" "}
              </li>
              <li className="flex items-start gap-2"><DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">Operating type </span>{" "}
              </li>
              <li className="flex items-start gap-2"><DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">Pages type </span>{" "}
              </li>
              <li className="flex items-start gap-2"><DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">Date and time of access </span>{" "}
              </li>
            </ul>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              If you voluntarily submit information through a contact form or
              appointment request, we may collect basic contact information such
              as your name, phone number, or email address for the purpose of
              responding to your inquiry.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Cookies & Website Analytics
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              We may use standard website analytics tools to understand how
              visitors interact with our website and to improve performance and
              usability. These tools may use cookies or similar technologies but
              do not collect personal medical information.
            </p>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              You may adjust your browser settings to limit or disable cookies.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Patient & Provider Portals
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              This website may include links to secure patient and provider
              portals operated by third-party vendors. Accessing those portals
              is governed by the applicable vendor privacy policies and terms.
            </p>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              For secure communication, access to medical records, and clinical
              information, please use the official patient or provider portal.
            </p>

            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              External Links
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              This website may contain links to external websites for
              informational purposes. Citrus Diagnostic Center is not
              responsible for the privacy practices or content of those external
              sites.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Security
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              We take reasonable administrative and technical steps to protect
              information submitted through this website. However, no website
              transmission can be guaranteed to be completely secure.
            </p>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              For sensitive or medical information, please use our secure
              portals or contact our office directly.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Changes to This Policy
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              We may update this Website Privacy Policy periodically. Any
              changes will be posted on this page with an updated effective
              date.
            </p>

            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Contact Us
            </h2>
            <h3 className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-4">
              If you have questions about this Website Privacy Policy, please
              contact:
            </h3>
            <ul className="xl:text-[1.33rem]  md:text-lg text-lg flex flex-col gap-3 text-[#ccc] lg:ps-0 md:px-8 px-4 pb-8  text-left font-robout">
              <li className="flex items-start gap-2 font-normal">
                <span className="">Phone : </span>{" "}
                <a href="tel:352-795-9200" className="hover:underline">
                  {" "}
                  352-795-9200
                </a>
              </li>
              <li className="flex items-start gap-2 font-normal">
                <span className="">Fax : </span>{" "}
                <a href="tel:352-795-6460" className="hover:underline">
                  {" "}
                  352-795-6460
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
